module.exports = __webpack_public_path__ + "img/2xs-rocks.2380dbe1.png";